import type { InvoiceQuerySchema } from '../schemas';

export const fieldNames: Record<keyof InvoiceQuerySchema, { name: string; revertible: boolean }> = {
  id: { name: 'ID', revertible: true },
  invoice_number: { name: 'Invoice #', revertible: true },
  invoice_date: { name: 'Invoice Date', revertible: true },
  invoice_batch_id: { name: 'Invoice Batch ID', revertible: true },
  client_id: { name: 'Company ID', revertible: true },
  client: { name: 'Company', revertible: true },
  brand_id: { name: 'Brand ID', revertible: true },
  brand: { name: 'Brand', revertible: true },
  partner_id: { name: 'Partner ID', revertible: true },
  partner: { name: 'Partner', revertible: true },
  notes: { name: 'Notes', revertible: true },
  execution_status: { name: 'Execution status', revertible: true },
  status: { name: 'Status', revertible: true },
  agreement_links: { name: 'Agreement Links', revertible: false },
  billing_contact: { name: 'Billing Contact', revertible: false },
  billing_email_contacts: { name: 'Billing Email Contacts', revertible: false },
  email_histories: { name: 'Email Histories', revertible: false },
  latest_email_history: { name: 'Latest Email History', revertible: false },
  due_date: { name: 'Due Date', revertible: true },
  invoice_amount: { name: 'Invoice Amount', revertible: true },
  subtotal_amount: { name: 'Subtotal Amount', revertible: true },
  on_account: { name: 'On Account', revertible: true },
  sub_total: { name: 'Sub Total', revertible: true },
  exempt: { name: 'Exempt', revertible: true },
  total: { name: 'Total', revertible: true },
  digital_invoices_pdf: { name: 'Digital Invoice PDF', revertible: false },
  printable_invoices_pdf: { name: 'Printable Invoice PDF', revertible: false },
  is_generating_pdfs: { name: 'Is Generating PDFs', revertible: true },
  account_receivables: { name: 'Accounts Receivable', revertible: false },
};
